import { TrafficPeriod } from '@app/pcs/models';
import * as fromCalendarEdit from '@app/pcs/reducer/calendar/calendar-edit';
import * as fromTrafficPeriods from '@app/pcs/reducer/calendar/traffic-periods';
import { combineReducers, createSelector } from '@ngrx/store';
import * as R from 'ramda';

export interface State {
  calendarEdit: fromCalendarEdit.State;
  trafficPeriods: TrafficPeriod[];
}

type GetCalendar = (s: State) => fromCalendarEdit.State;
const getCalendarEdit: GetCalendar = R.prop('calendarEdit');

export const getCalendar = createSelector(
  getCalendarEdit,
  fromCalendarEdit.getCalendar
);
type GetTrafficPeriods = (s: State) => TrafficPeriod[];
export const getTrafficPeriods: GetTrafficPeriods = R.prop('trafficPeriods');

export const initialState: State = {
  calendarEdit: fromCalendarEdit.initialState,
  trafficPeriods: fromTrafficPeriods.initialState
};

export const reducer = combineReducers<State>({
  calendarEdit: fromCalendarEdit.reducer,
  trafficPeriods: fromTrafficPeriods.reducer
});
